export const X = "X";
export const Y = "Y";
export const Z = "Z";
export const ARROWS_DISTANCE = "Arrows distance";
export const ARROWS_ROTATION = "Arrows rotation";
export const CIRCLE_SIZE = "Circle size";
export const PODIUM_SCALE = "Podium scale";
export const RESIZE_MODEL = "Resize model";
export const ROTATE_MODEL = "Rotate model";
export const ROTATE_FLOORS = "Rotate floors";
export const LINE_START = "Line start";
export const LINE_WIDTH = "Line width";
export const LINE_COLOR = "Line color";
export const MAX_DISTANCE = "Max distance";
export const TRANSPARENCY = "Transparency";
export const MIN_POLAR_ANGLE = "Min polar angle";
export const MAX_POLAR_ANGLE = "Max polar angle";
export const SHOW_INITIAL_ANIMATION = "Show initial animation";
export const SHOW_OCEAN = "Show ocean";
export const ENABLE_APARTMENT_TOUR = "Enable apartment tour";
export const LABEL_SIZE = "Label size";
export const MODEL_NAME = "Model name";
export const DEFAULT = "Default";
export const APARTMENT = "Apartment";
export const FLOOR = "Floor";
export const BUILDING = "Building";
export const ORBIT = "Orbit";
export const STEADY = "Steady";
export const MAPBOX_TOKEN = "pk.eyJ1IjoieWFtaXRoYWZha290IiwiYSI6ImNsaWhsMnBpczBxaTkzZHFyZDdpaWp4c3MifQ.N2Batt6nrfHv-rjUo_EYAQ";
